import { ajax } from '@vo/js/utils/helpers'
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

const { __ } = wp.i18n

export default class AddToCart {
    static initAll() {
        const addToCartButtons = document.querySelectorAll('[data-add-to-cart]')
        addToCartButtons.forEach((button) => new AddToCart(button).bindEvents())
    }

    static initAllInNode(node) {
        const addToCartButtons = node.querySelectorAll('[data-add-to-cart]')
        addToCartButtons.forEach((button) => new AddToCart(button))
    }

    static getCartItemCountNodes() {
        return document.querySelectorAll('[data-cart-item-count]')
    }

    static getQuantity(id) {
        const node = document.querySelector(`input[data-add-to-cart-quantity="${id}"]`)
        if (!node) return 1

        const quantity = parseInt(node.value)
        if (isNaN(quantity)) return 1

        return quantity
    }

    constructor(element) {
        this.element = element
    }

    bindEvents() {
        this.element.addEventListener('click', this.handleClick.bind(this))
    }

    handleClick(e) {
        e.preventDefault()

        const target = e.currentTarget
        const productId = this.element.dataset.addToCart
        if (!productId) return
        const quantity = AddToCart.getQuantity(productId)

        this.addToCart(productId, quantity, target)
    }

    async addToCart(id, quantity, target, subscription = false, attributes = []) {
        if (target.classList.contains('is-loading')) return

        target.classList.add('is-loading')
        target.classList.remove('is-added')

        // ajax function to add product to cart
        try {
            await ajax(window.customData.apiWcStoreURL + 'cart/add-item', { id, quantity, active_subscription_scheme: subscription, variation: attributes }, 'POST', true, true)
                .then((response) => {
                    if (!response.ok) throw new Error('Something went wrong. Please try again.')
                    return response.json()
                })
                .then((response) => {
                    if (!response) return

                    if (response.items_count) {
                        AddToCart.getCartItemCountNodes().forEach((node) => {
                            node.textContent = response.items_count
                        })
                    }

                    target.classList.add('is-added')

                    setTimeout(() => {
                        target.classList.remove('is-added')
                    }, 5 * 1000)

                    const cartWrapper = document.querySelector('[data-cart-wrapper]')
                    if (cartWrapper) {
                        cartWrapper.classList.add('is-added')
                        setTimeout(() => {
                            cartWrapper.classList.remove('is-added')
                        }, 1000)
                    }

                    Toastify({
                        className: 'vo-toast',
                        text: __('Product added to cart (view)', 'van-ons'),
                        duration: 3000,
                        destination: window.customData.cartURL,
                        gravity: 'bottom',
                        position: 'center',
                        close: false,
                    }).showToast()
                })
        } catch (error) {
            target.classList.add('has-failed')
            setTimeout(() => {
                target.classList.remove('has-failed')
            }, 5 * 1000)

            console.error(error)
        }

        target.classList.remove('is-loading')
    }
}
